import {
  VehicleGroup,
  VehicleGroupEditFormValues,
  VehicleGroupRow,
  VehicleGroupVehicleRow,
} from "./types";

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE GROUP 
-----------------------------------------------------------------------------------------*/

export const transformVehicleGroup = (res: any): VehicleGroup => {
  return {
    id: res.id,
    name: res.name,
    parentVehicleGroupId: res.parentVehicleGroup?.id,
    parentVehicleGroupName: res.parentVehicleGroup?.name,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE GROUP SEARCH
-----------------------------------------------------------------------------------------*/

export const transformVehicleGroupRow = (res: any): VehicleGroupRow => {
  return {
    id: res.id,
    name: res.name,
    parentVehicleGroupId: res.parentVehicleGroup?.id,
    parentVehicleGroupName: res.parentVehicleGroup?.name,
    breadcrumbs: res.breadcrumbs,
  };
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE GROUP CREATE
  -----------------------------------------------------------------------------------------*/

export const transformVehicleGroupOnCreate = (
  formValues: VehicleGroupEditFormValues
): any => ({
  name: formValues.name,
  parentVehicleGroupId: formValues.parentVehicleGroupId,
});

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE GROUP EDIT
-----------------------------------------------------------------------------------------*/

export const transformVehicleGroupOnUpdate = (
  formValues: VehicleGroupEditFormValues
): any => ({
  id: formValues.id,
  name: formValues.name,
  parentVehicleGroupId: formValues.parentVehicleGroupId,
});

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE GROUP VEHICLES SEARCH
-----------------------------------------------------------------------------------------*/

export const transformVehicleGroupVehiclesRow = (
  res: any
): VehicleGroupVehicleRow => {
  return {
    id: res.id,
    kmTraveled: res.kmTraveled,
    manufacturer: res.manufacturer,
    model: res.model,
    type: res.type,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE GROUP VEHICLES  CREATE
-----------------------------------------------------------------------------------------*/

export const transformVehicleGroupVehiclesOnCreate = (
  vehicleIds: number[]
): any => ({
  vehicleIds: vehicleIds,
});
